// prefix to storage account, use for images
export const prefix = "https://considtvstore.blob.core.windows.net/bilder/";

export const staticPrefix =
  "https://considtvstore.blob.core.windows.net/static/";

// base url for db
export const base = "https://considtv-api-apim.azure-api.net/considtv-api/";
